export const AutoParentalLockService = {
    timeout: null,

    startTimeout(minutes, onTimeoutEnd) {
        this.clearTimeout();
        console.log(`Parental lock timeout initialized. Timeout is set on ${minutes} minutes`);
        this.timeout = setTimeout(() => {
            if (typeof onTimeoutEnd === 'function') {
                onTimeoutEnd();
            }
        }, minutes * 60000);
    },

    clearTimeout() {
        clearTimeout(this.timeout);
    }
};
